<h1 matDialogTitle>Search Stock Code</h1>

<mat-dialog-content>
    <app-search-stock-code-ecom-menu [customerCode]="data.customerCode" [salesOrderHeaderId]="data.salesOrderHeaderId"
        [salesOrderNumber]="data.salesOrderNumber" (stockCodeSelected)="stockCodeSelected($event)">
    </app-search-stock-code-ecom-menu>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button matDialogClose (click)="close()">Close</button>
    <button mat-button [disabled]="!selectedStockCode" (click)="add()">Add Stock Code</button>

</mat-dialog-actions>